import validate from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.2.2_@azure+identity@4.13.0_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc_l3nsa5ukhbotzjub7wsb6zvnji/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.2.2_@azure+identity@4.13.0_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc_l3nsa5ukhbotzjub7wsb6zvnji/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-auth": () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/middleware/check-auth.ts")
}